export const LOAD_REQUESTED = "ADMIN_WORKFLOW_STATUS/LOAD_REQUESTED";
export const LOAD_SUCCESS = "ADMIN_WORKFLOW_STATUS/LOAD_SUCCESS";
export const LOAD_FAIL = "ADMIN_WORKFLOW_STATUS/LOAD_FAIL";

// eslint-disable-next-line no-unused-vars
export default (state = {}, { type, data }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoadAdminWorkflowStatus = data => ({ type: LOAD_REQUESTED, data });
export const successLoadAdminWorkflowStatus = data => ({ type: LOAD_SUCCESS, data });
export const failLoadAdminWorkflowStatus = data => ({ type: LOAD_FAIL, data });
